import { API_TYPE } from "../../constants";
import { makeApiCall } from "../makeApiCall";
import { CheckerService_URL, PickerService_URL } from "../Url";

export const PickerTOActions = {
  SAVE_QUANTITY_BOX_SUCCESS: "SAVE_QUANTITY_BOX_SUCCESS",
  SAVE_QUANTITY_BOX_FAILURE: "SAVE_QUANTITY_BOX_FAILURE",
  GET_MEDICINES_IN_BOX_SUCCESS: "GET_MEDICINES_IN_BOX_SUCCESS",
  GET_MEDICINES_IN_BOX_FAILURE: "GET_MEDICINES_IN_BOX_FAILURE",
  GET_REASONS_LIST_SUCCESS: "GET_REASONS_LIST_SUCCESS",
  GET_REASONS_LIST_FAILURE: "GET_REASONS_LIST_FAILURE",
  MARK_PICKER_ISSUE_SUCCESS: "MARK_PICKER_ISSUE_SUCCESS",
  MARK_PICKER_ISSUE_FAILURE: "MARK_PICKER_ISSUE_FAILURE",
  GET_CHECKER_REASONS_LIST_SUCCESS: "GET_CHECKER_REASONS_LIST_SUCCESS",
  GET_CHECKER_REASONS_LIST_FAILURE: "GET_CHECKER_REASONS_LIST_FAILURE",
};

export function saveQuantityInBoxSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: PickerTOActions.SAVE_QUANTITY_BOX_SUCCESS,
      payload: props,
    });
  };
}

export function saveQuantityInBoxError(error) {
  return {
    type: PickerTOActions.SAVE_QUANTITY_BOX_FAILURE,
    payload: error,
  };
}

export function saveQuantityInBoxThunk(params) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + params.access_token,
  };
  let url = `${PickerService_URL}/saveQuantityInBox?`;

  let tempUrl = "";
  if (Object.keys(params.data).length > 0) {
    Object.keys(params.data).forEach((e) => {
      switch (e) {
        case "toNumber":
          tempUrl += `&toNumber=${params.data.toNumber}`;
          break;
        case "boxNumber":
          tempUrl += `&boxNumber=${params.data.boxNumber}`;
          break;
        case "productCode":
          tempUrl += `&productCode=${params.data.productCode}`;
          break;
        case "quantity":
          tempUrl += `&quantity=${params.data.quantity}`;
          break;
        default:
          break;
      }
    });
  }
  if (tempUrl) {
    tempUrl = tempUrl.slice(1);
  }

  url += tempUrl;

  return makeApiCall(
    url,
    saveQuantityInBoxSuccess,
    saveQuantityInBoxError,
    "POST",
    null,
    reqHeader,
    params.history,
    API_TYPE.NEW
  );
}

export function getMedsInBoxSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: PickerTOActions.GET_MEDICINES_IN_BOX_SUCCESS,
      payload: props,
    });
  };
}

export function getMedsInBoxError(error) {
  return {
    type: PickerTOActions.GET_MEDICINES_IN_BOX_FAILURE,
    payload: error,
  };
}

export function getMedsInBoxThunk(params) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + params.access_token,
  };
  let url = `${PickerService_URL}/getMedsInBox?`;

  let tempUrl = "";
  if (Object.keys(params).length > 0) {
    Object.keys(params).forEach((e) => {
      switch (e) {
        case "toNumber":
          tempUrl += `&toNumber=${params.toNumber}`;
          break;
        default:
          break;
      }
    });
  }
  if (tempUrl) {
    tempUrl = tempUrl.slice(1);
  }

  url += tempUrl;

  return makeApiCall(
    url,
    getMedsInBoxSuccess,
    getMedsInBoxError,
    "GET",
    null,
    reqHeader,
    params.history,
    API_TYPE.NEW
  );
}

export function getReasonsListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: PickerTOActions.GET_REASONS_LIST_SUCCESS,
      payload: props,
    });
  };
}

export function getReasonsListError(error) {
  return {
    type: PickerTOActions.GET_REASONS_LIST_FAILURE,
    payload: error,
  };
}

export function getReasonsListThunk(params) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + params.access_token,
  };
  let url = `${
    params.reasonType === "CHECKER_REASON"
      ? CheckerService_URL
      : PickerService_URL
  }/getReasonMaster?`;

  let tempUrl = "";
  if (Object.keys(params).length > 0) {
    Object.keys(params).forEach((e) => {
      switch (e) {
        case "reasonType":
          tempUrl += `&reasonName=${params.reasonType}`;
          break;
        default:
          break;
      }
    });
  }
  if (tempUrl) {
    tempUrl = tempUrl.slice(1);
  }

  url += tempUrl;

  return makeApiCall(
    url,
    getReasonsListSuccess,
    getReasonsListError,
    "GET",
    null,
    reqHeader,
    params.history,
    API_TYPE.NEW
  );
}

// ----------- Checker reason list

export function getCheckerReasonsListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: PickerTOActions.GET_CHECKER_REASONS_LIST_SUCCESS,
      payload: props,
    });
  };
}

export function getCheckerReasonsListError(error) {
  return {
    type: PickerTOActions.GET_CHECKER_REASONS_LIST_FAILURE,
    payload: error,
  };
}

export function getCheckerReasonsListThunk(params) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + params.access_token,
  };
  let url = `${
    params.reasonType === "CHECKER_REASON"
      ? CheckerService_URL
      : PickerService_URL
  }/getReaonsList?`;

  let tempUrl = "";
  if (Object.keys(params).length > 0) {
    Object.keys(params).forEach((e) => {
      switch (e) {
        case "reasonType":
          tempUrl += `&${
            params.reasonType === "CHECKER_REASON"
              ? "reasonType="
              : "reasonName="
          }${params.reasonType}`;
          break;
        default:
          break;
      }
    });
  }
  if (tempUrl) {
    tempUrl = tempUrl.slice(1);
  }

  url += tempUrl;

  return makeApiCall(
    url,
    getCheckerReasonsListSuccess,
    getCheckerReasonsListError,
    "GET",
    null,
    reqHeader,
    params.history,
    API_TYPE.NEW
  );
}

// -----------

export function markPickerIssueSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: PickerTOActions.MARK_PICKER_ISSUE_SUCCESS,
      payload: props,
    });
  };
}

export function markPickerIssueError(error) {
  return {
    type: PickerTOActions.MARK_PICKER_ISSUE_FAILURE,
    payload: error,
  };
}

export function markPickerIssueThunk(params) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + params.access_token,
  };
  let url = `${PickerService_URL}/markPickerIssue?`;

  let tempUrl = "";
  if (Object.keys(params).length > 0) {
    Object.keys(params).forEach((e) => {
      switch (e) {
        case "toNumber":
          tempUrl += `&toNumber=${params.toNumber}`;
          break;
        case "quantity":
          tempUrl += `&quantity=${params.quantity}`;
          break;
        case "productCode":
          tempUrl += `&productCode=${params.productCode}`;
          break;
        case "reasonId":
          tempUrl += `&reasonId=${params.reasonId}`;
          break;
        default:
          break;
      }
    });
  }
  if (tempUrl) {
    tempUrl = tempUrl.slice(1);
  }

  url += tempUrl;

  return makeApiCall(
    url,
    markPickerIssueSuccess,
    markPickerIssueError,
    "POST",
    null,
    reqHeader,
    params.history,
    API_TYPE.NEW
  );
}
